import React, { Component } from "react";
import { Card, CardDeck, Row, Col, Container, Button } from "react-bootstrap";
import "../../css/Managehssestyle.css";
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/customBootstrapExtended.css';
import '../../css/UpdateUserProfile.css';
import '../../css/MyReportstylee.css';
import queryString from 'query-string'

import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'
import Stepper from 'react-stepper-horizontal';
import { Link } from 'react-router-dom'; // Add this line
import Swal from 'sweetalert2'


function Iframe(props) {
  console.log("URL Calling : ", props.src)
  return (
    <div>
      <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
    </div>
  )
}

const currentDate = new Date();
const currentHours = currentDate.getHours();

if (currentHours < 5) { // AM hours
  currentDate.setDate(currentDate.getDate() + 1); // Add one day
}



class GeneralReports extends Component {
  constructor(props) {
    super(props);
    debugger
    //const currentDate = new Date();
    

    const tomorrowDate = new Date(currentDate.getTime() + 24 * 60 * 60 * 1000);
    this.state = {
      showReport: false,
      srcURL: '',
      //reportBaseURL: 'http://localhost:40383/Reports?',
      reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Reports?',
      reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
      reportViewType: '/SSSAS_TabularReports/',
      UserBranchID: this.props.data.selectedBranchId,
      reportDuration: 3,
      reportName: 'ShellCardTransactions',
      reportStartDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10),
      reportEndDate: currentDate.toISOString().substring(0, 10),
      //new Date().toISOString().substring(0, 10),
      // reportEndDate: tomorrowDate.toISOString().substring(0, 10),
      trendReportType: '',
      trendReportDuration: '',
      GeneralReportsteps: [
        {
          title: 'Step One',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 1)
          }
        },
        {
          title: 'Step Two',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 2)
          }
        }
      ],
      GRcurrentStep: 1,
      PageSize: 5,
      Option: 1,
      Group: 0,
      Vehicle: 0,
      GroupText: '',

    };
    
    // const StartReportDate = localStorage.getItem('fromDateTransReport');
    // const EndReportDate = localStorage.getItem('toDateTransReport');


    // this.setState({ [this.state.reportStartDate]: [StartReportDate] });
    // this.setState({[this.state.reportEndDate]:[EndReportDate]})
    // // this.setState({[this.state.reportname]:["Shell Card Transactions"]})

    this.onClickNext_GR = this.onClickNext_GR.bind(this);
    this.onClickPrevious_GR = this.onClickPrevious_GR.bind(this)

    this.handleChange = this.handleChange.bind(this)

    this.optionChange = this.optionChange.bind(this)
    this.groupChange = this.groupChange.bind(this)
    this.vehicleChange = this.vehicleChange.bind(this)
    this.fetchReport = this.fetchReport.bind(this)

    this.generalReportSubmitHandler = this.generalReportSubmitHandler.bind(this)
  }
  
  onClickNext_GR() {
    if (this.state.GRcurrentStep < 2)
      debugger
       console.log(this.state.Option,'option');
       console.log(this.state.Vehicle,'Vehicle');
       console.log(this.state.Group,'Group');
       if(this.state.Option == "1")
    {
      
      this.setState({ showReport: false }) 
    this.setState({
      GRcurrentStep: this.state.GRcurrentStep + 1,
    });
   }
  if((this.state.Option == "2" && this.state.Group != 0 || this.state.GroupText == "DEFAULT-GROUP"))
   {
    this.setState({ showReport: false })
    this.setState({
      GRcurrentStep: this.state.GRcurrentStep + 1,
    });
   }
   if(this.state.Option == "3" && this.state.Vehicle != 0)
   {
    this.setState({ showReport: false })
    this.setState({
      GRcurrentStep: this.state.GRcurrentStep + 1,
    });
   }
  }

  onClickPrevious_GR() {
    debugger
    console.log(this.state.GRcurrentStep)
    if (this.state.GRcurrentStep > 0)
      this.setState({
        GRcurrentStep: this.state.GRcurrentStep - 1,
        Group:0,
        GroupText:'',
        Vehicle:0
      });
      this.setState({Option : 1})
  }

  // onClickPrevious_GR() {
  //   console.log(this.state.GRcurrentStep)
  //   if (this.state.GRcurrentStep > 1)
  //     this.setState({
  //       GRcurrentStep: this.state.GRcurrentStep - 1,
  //       Group:0,
  //       GroupText:'',
  //       Vehicle:0
  //     });
  // }

  fetchReport() {
    this.setState({ showReport: true })
  }

  async optionChange(selectedOption) {
    
    if (this.state.Option != selectedOption && selectedOption == 1) {
      await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }
    else
      this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
  }

  async vehicleChange(selectedVehicle) {
    debugger
    console.log(selectedVehicle,'SelectedVehicle')
    await this.setState({ Vehicle: selectedVehicle, Group: 0 })
    //this.getAnalyticsData()

  }

  async groupChange(selectedGroup,selectedGroupText) {
    debugger
    console.log(selectedGroup,'SelectedGroup');

    
    await this.setState({ Group: selectedGroup, Vehicle: 0 ,GroupText :selectedGroupText })
    //this.getAnalyticsData()

  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  generalReportSubmitHandler(e) {
    Swal.fire({
      title: 'Please Wait ...',
      onBeforeOpen() {
        Swal.showLoading()
      },
      onAfterClose() {
        Swal.hideLoading()
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false
    });

    console.log("Selected vehicle is ", this.state.Vehicle)
    e.preventDefault();
    console.log("Running Tabular Report")
    this.setState({ showReport: false })
    let fromDate = this.GetFormattedDate(this.state.reportStartDate)
    let toDate = this.GetFormattedDate(this.state.reportEndDate)
    let UserBranchID = this.state.UserBranchID
    let reportName = this.state.reportName
    // let reportName = "ShellCardTransactions"
    let URL_PARAMETERS = 'reportName=' + reportName + '&FromDate=' + fromDate + '&ToDate=' + toDate + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
    if (this.state.Option == '2' || this.state.Option == '3') {
      if (this.state.Option == '2')
        URL_PARAMETERS += '&VRNGroupingID=' + this.state.Group
      else if (this.state.Option == '3')
        URL_PARAMETERS += '&MappingMasterID=' + this.state.Vehicle
    }
    let reportViewType = this.state.reportViewType
    let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
    console.log('URL Generated: ', ReportFullURL)

    // this.setState({ srcURL: ReportFullURL, showReport: true })
    setTimeout(() => {
      this.setState({ srcURL: ReportFullURL, showReport: true });
      Swal.close();
    }, 2000); // Adjust the delay as needed
    }
  

  GetFormattedDate(dateToConvert) {
    debugger
    var date = new Date(dateToConvert)
    return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
  }

  // GetFormattedDate(dateToConvert) {
  //   var date = new Date(dateToConvert);
  //   var month = (date.getMonth() + 1).toString().padStart(2, '0'); // Ensure 2-digit month
  //   var day = date.getDate().toString().padStart(2, '0'); // Ensure 2-digit day
  //   var year = date.getFullYear();
  
  //   return month + '/' + day + '/' + year;
  // }
  

   

  componentDidMount() {

    const queryStringValue = queryString.parse(this.props.location.search);
    const value = queryStringValue.reportType;

    if(value != undefined)
    {
      this.setState({reportName: value})
    }

  }

  render() {
    console.log("Report Props: ", this.props)
    const { GeneralReportsteps, GRcurrentStep } = this.state;
    const { TrendReportsteps, TRcurrentStep } = this.state;
    const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };

    return (
      
      <div>
          <div style={{ textAlign: 'left', marginLeft: '30px' }}>

<Link to="/EventAndReports" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

</div>

          <div className="row">
            <div className="col-sm-12">

                            <Card>
                              <Card.Title className="card-header">
                                {/* Shell Card Transactions Report */}
                                Fleet Overview Report
                              </Card.Title>
                              <Card.Body className="card-content">

                                <Stepper
                                  steps={GeneralReportsteps}
                                  activeStep={GRcurrentStep}
                                  activeColor="#ffd500"
                                  defaultBarColor="#ffd500"
                                  completeColor="red"
                                  // completeColor="red"
                                  completeBarColor="#ffd500"
                                  defaultBorderColor="green"
                                />


                                {GRcurrentStep === 1 && (
                                  <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                      <GroupVRNSelect

                                        showVehiclesInDropDown='yes'
                                        isMultiInGroup='false'
                                        isMultiInVehicle='false'
                                        onOptionChange={this.optionChange}
                                        onGroupChange={this.groupChange}
                                        onVehicleChange={this.vehicleChange}

                                      ></GroupVRNSelect>
                                    </div>


                                  </>

                                )}


                                {GRcurrentStep === 2 && (
                                  <>

                                    <form className="form" onSubmit={this.generalReportSubmitHandler} >
                                      <div className="form-body">
                                        <div className="row">
                                          <div className="col-md-6 col-12">
                                            <div className="form-group" style={{display:"none"}}>
                                              {/* <label htmlFor="ReportType">Choose Report Type</label> */}
                                              {/* <p className="text-left">Choose Report Type</p> */}
                                              <p className="text-left">Report Type</p>
                                              <select class="form-control" value={this.state.reportName} name='reportName' onChange={this.handleChange.bind(this)} required>
                                                {/* <option value="">
                                                  Please Select
                                                </option> */}
                                                <option value="ShellCardTransactions">
                                                  Shell Card Transactions
                                                </option>
                                                {/* <option value="DriverOverviewReport">
                                                  Driver Overview Report
                                                </option>
                                                <option value="SafetyViolation">
                                                  Safety Violations
                                                </option>
                                                <option value="AlertDeliveryReport">
                                                  Alert Delivery Report
                                                </option>
                                                <option value="ManaulAdjustmentTransaction">
                                                  Manual Adjusted Transactions Report
                                                </option> */}

                                              </select>
                                              {/* <input class="form-control" value="ShellCardTransactions"  name='reportName' onChange={this.handleChange.bind(this)} required>
                                              </input> */}
                                            </div>
                                          </div>
                                          <div className="col-md-6 col-12">
                                            &nbsp;
                                          </div>
                                          <div className="col-md-6 col-12">
                                            <div className="form-label-group" >
                                              <input type="date" id="dpStartTime" name="reportStartDate" value={this.state.reportStartDate} onChange={this.handleChange.bind(this)} className="form-control custom-date-input" onKeyDown={(e) => e.preventDefault()}  max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)} />
                                              <label htmlFor="country-floating" style={{ fontWeight: 'bold' }}>From Date</label>
                                            </div>
                                          </div>
                                          <div className="col-md-6 col-12" >
                                            <div className="form-label-group">
                                              <input type="date" id="dpEndTime" name="reportEndDate" value={this.state.reportEndDate} onChange={this.handleChange.bind(this)} className="form-control " 
                                              onKeyDown={(e) => e.preventDefault()}
                                              min={this.state.reportStartDate} // Min date is "From Date"
                                              max={ new Date(currentDate.getTime()).toISOString().substring(0, 10)}/>
                                              <label htmlFor="country-floating" style={{ fontWeight: 'bold'}}>To Date</label>
                                            </div>
                                          </div>
                                          <div className="col-12">
                                            <button type="submit" className="btn btn-shell mr-1 mb-1">Generate Report</button>
                                          </div>

                                          <div className="col-md-12 col-12">
                                            {this.state.showReport && <Iframe src={this.state.srcURL} height="300" width="100%" />}
                                          </div>
                                        </div>
                                      </div>


                                    </form>



                                  </>

                                )}


                                <div >

                                {this.state.GRcurrentStep != 1 && 
                                  <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious_GR}>Previous</Button></div>
                                }
                                  
                                  {this.state.GRcurrentStep != 2 && 
                                  <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext_GR}>Next</Button></div>
                                  }
                                </div>




                              </Card.Body>
                            </Card>
            </div>
          </div>
      </div>


    );
  }
}
export default GeneralReports;